import React from 'react';
import { ISendReceipt } from '@components/Sura/SendReceipt/types';
import { Grid, Typography, Button } from '@material-ui/core';
import useStyles from '@components/Sura/SendReceipt/styles';
import { observer } from 'mobx-react';
import Divider from '@material-ui/core/Divider';
import useStore from '@hooks/useStore';
import FormSendReceipt from '@components/Sura/SendReceipt/FormSendReceipt/FormSendReceipt';
import { PaymentMethod } from '@store/sura';

const SendReceipt: React.FC<ISendReceipt> = ({ title }) => {
  const { links, ui, sura } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });

  const handlePayOther = () => {
    window.location.href = links.paymentLink.settings.redirectUrl;
  };

  return (
    <Grid className={css.divSend}>
      <Typography className={css.labelSend}>{title}</Typography>
      <div className={css.divForm}>
        <FormSendReceipt type={'email'} />
        {sura.paymentMethod !== PaymentMethod.bankReference &&
          sura.paymentMethod !== 'send-reference' && <FormSendReceipt type={'sms'} />}
      </div>
      <Divider variant="fullWidth" className={css.divider} />
      <div className={css.divButtonsOther}>
        <Button className={css.buttonPayOther} onClick={handlePayOther}>
          Pagar otra póliza
        </Button>
        <Button className={css.buttonMoreSura}>Conocer más de Seguros Sura</Button>
      </div>
    </Grid>
  );
};

export default observer(SendReceipt);
